module.exports = __webpack_public_path__ + "img/img3.af57369b.png";